import React, { useState, Fragment, useContext, useEffect } from 'react';
import { Alert } from 'reactstrap';

import ProductoImages from "./ProductoImages";
import functions from "../../components/Tienda/functions/functions.js";

import { CartContext } from "../../components/Tienda/components/ParadigmaCartProvider";
import superOferta from "../../assets/img/tienda/SuperOferta.png";
import CantidadSelectorController from "../../components/Tienda/components/CantidadSelector/CantidadSelectorController";
import { GlobalConfigTienda } from '../TiendaConfig';

import imagenNoDisponible from '../../assets/img/tienda/image_not_found.png';

import './styles.scss';

const CUOTAS = 6;
const WHATSAPP_NUMBER = '5492915061230';

const buildWhatsappUrl = (producto) => {
  const text = `Hola, quiero consultar por: ${producto.Titulo || ''} (cód. ${producto.code})`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
};

const toSentenceCase = (str) => {
  if (!str) return '';
  return str
    .toLowerCase()
    .replace(/(^|\s|\(|\/|-)([a-záéíóúñ])/g, (_, sep, ch) => sep + ch.toUpperCase());
};

const ProductoCaracteristicas = ({ propiedades }) => {
  if (!propiedades || propiedades.length === 0) return null;
  return (
    <div className="esige-producto-detail">
      {propiedades.map((item, index) => (
        <Fragment key={`prop-${index}`}>
          <span>{item.Propiedad}</span>
          <span>{item.Valor === '' || item.Valor === 'No Disponible' ? '———' : item.Valor}</span>
        </Fragment>
      ))}
    </div>
  );
};

const ProductoDescripcion = ({ text }) => {
  if (text === undefined || text === null || text === "") return null;
  if (functions.isHTML(text)) {
    return <div dangerouslySetInnerHTML={{ __html: text }} />;
  }
  return (
    <ul className="list-unstyled mb-0">
      {text.split('\n').map((x, i) => <li key={`line-${i}`}>{x}</li>)}
    </ul>
  );
};

const TrustSignals = ({ stockDisponible }) => (
  <ul className="esige-producto-trust">
    {stockDisponible && (
      <li>
        <i className="fa fa-check-circle" aria-hidden="true"></i>
        <span><strong>Stock disponible</strong></span>
      </li>
    )}
    <li>
      <i className="fa fa-credit-card" aria-hidden="true"></i>
      <span>{CUOTAS} cuotas sin interés con tarjeta</span>
    </li>
    <li>
      <i className="fa fa-shopping-bag" aria-hidden="true"></i>
      <span>Retiro en sucursal</span>
    </li>
    <li>
      <i className="fa fa-truck" aria-hidden="true"></i>
      <span>Envíos a coordinar en la zona</span>
    </li>
  </ul>
);

const useCantidad = ({ code, talle_id, color_id }) => {
  const cartContext = useContext(CartContext);
  const enCarrito = cartContext.getCantidadItem({ code, talle_id, color_id });
  const [cantidad, setCantidad] = useState(enCarrito > 0 ? enCarrito : 1);
  return [cantidad, setCantidad];
};

const PanelCompra = ({ producto }) => {
  const cartContext = useContext(CartContext);
  const [{ talle_id, color_id }] = useState({ talle_id: null, color_id: null });
  const cartItem = { code: producto.code, talle_id, color_id };
  const [cantidad, setCantidad] = useCantidad(cartItem);

  const enCarrito = cartContext.getCantidadItem(cartItem);
  const stock = functions.getMaxQuantity(producto, talle_id, color_id);
  const stockDisponible = producto.IgnorarStock || stock > 0;
  const ofertaActiva = producto.OfertaPeriodo_FechaDesde != null
    && producto.OfertaPeriodo_FechaHasta != null
    && Date.parse(producto.OfertaPeriodo_FechaHasta) >= Date.now();
  const ofertaCantidad = producto.OfertaNxM_Cantidad > 0;

  useEffect(() => {
    const en = cartContext.getCantidadItem(cartItem);
    setCantidad(en > 0 ? en : 1);
  }, [cartContext, talle_id, color_id]);

  if (!(producto.Precio > 0)) {
    return (
      <aside className="esige-producto-panel">
        <div className="esige-producto-panel__sin-precio">
          <p>Precio a consultar</p>
          <a
            href={buildWhatsappUrl(producto)}
            target="_blank" rel="noopener noreferrer"
            className="btn btn-success btn-lg w-100 font-weight-bold"
          >
            <i className="fa fa-whatsapp mr-2" aria-hidden="true"></i>
            Consultar por WhatsApp
          </a>
        </div>
        <TrustSignals stockDisponible={stockDisponible} />
      </aside>
    );
  }

  const precioActual = producto.PrecioSuperOferta > 0 ? producto.PrecioSuperOferta : producto.Precio;
  const precioFormatted = "$ " + functions.FormatPrice(precioActual, GlobalConfigTienda.NumeroDecimales);
  const cuotaFormatted = "$ " + functions.FormatPrice(precioActual / CUOTAS, GlobalConfigTienda.NumeroDecimales);
  const tieneOferta = producto.DescuentoSuperOferta > 0;

  return (
    <aside className="esige-producto-panel">
      {tieneOferta && (
        <div className="esige-producto-panel__oferta-tag">
          <img src={superOferta} alt="Oferta" />
        </div>
      )}

      <div className="esige-producto-panel__price-block">
        <div className="esige-producto-panel__price">{precioFormatted}</div>
        <div className="esige-producto-panel__price-meta">
          {tieneOferta ? "Precio de oferta con IVA" : "Precio final con IVA"}
        </div>
        <div className="esige-producto-panel__cuotas">
          <i className="fa fa-credit-card" aria-hidden="true"></i>
          <span>{CUOTAS} cuotas sin interés de <strong>{cuotaFormatted}</strong></span>
        </div>
      </div>

      {ofertaActiva && (
        <Alert color="success" className="text-center mt-3 mb-0 py-2">
          Oferta vigente hasta {functions.FormatDate(Date.parse(producto.OfertaPeriodo_FechaHasta))}
        </Alert>
      )}
      {ofertaCantidad && !ofertaActiva && (
        <Alert color="success" className="text-center mt-3 mb-0 py-2">
          Llevando {producto.OfertaNxM_Cantidad} o más unidades:
          {' $'}{functions.FormatPrice(producto.OfertaNxM_Precio, GlobalConfigTienda.NumeroDecimales)}
        </Alert>
      )}

      {producto.PuedeComprar && (
        <>
          <div className="esige-producto-panel__compra">
            <div className="esige-producto-panel__cantidad">
              <span className="esige-producto-panel__cantidad-label">Cantidad</span>
              <CantidadSelectorController
                cantidadDisponible={stock}
                cantidad={cantidad}
                onChange={(c) => setCantidad(c)}
              />
            </div>
            <button
              disabled={!producto.IgnorarStock && stock <= 0}
              onClick={() => cartContext.setItem({ ...cartItem, quantity: cantidad })}
              className="btn btn-success font-weight-bold esige-producto-panel__btn-add"
            >
              <i className="fa fa-shopping-cart mr-2" aria-hidden="true"></i>
              {enCarrito ? "Actualizar carrito" : "Agregar al carrito"}
            </button>
          </div>
          <a
            href={buildWhatsappUrl(producto)}
            target="_blank" rel="noopener noreferrer"
            className="btn btn-outline-success font-weight-bold esige-producto-panel__btn-wapp"
          >
            <i className="fa fa-whatsapp mr-2" aria-hidden="true"></i>
            Consultar por WhatsApp
          </a>
        </>
      )}

      <TrustSignals stockDisponible={stockDisponible} />
    </aside>
  );
};

const ProductoBody = ({ producto, loading, magnifier }) => {
  if (loading || !producto) return null;

  const imagenes = (producto.Imagenes && producto.Imagenes.length > 0)
    ? producto.Imagenes
    : [{ src: imagenNoDisponible, talle_id: null, color_id: null }];

  return (
    <div className="esige-producto-container container">
      <div className="row esige-producto-main-detail align-items-start">
        <ProductoImages
          magnifier={magnifier !== undefined && magnifier !== null ? magnifier : true}
          images={imagenes}
        />
        <div className="col-md-7 col-lg-6 esige-producto-info">
          <div className="esige-producto-info__inner">
            <h1 className="esige-producto-title__h1">{toSentenceCase(producto.Titulo)}</h1>
            {producto.code && (
              <div className="esige-producto-codigo">Código: {producto.code}</div>
            )}
            <PanelCompra producto={producto} />
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-12">
          {producto.Propiedades && producto.Propiedades.length > 0 && (
            <section className="esige-producto-section mb-4">
              <h2 className="esige-producto-section__title">Características</h2>
              <ProductoCaracteristicas propiedades={producto.Propiedades} />
            </section>
          )}
          {(producto.Info || producto.Descripcion) && (
            <section className="esige-producto-section">
              <h2 className="esige-producto-section__title">Descripción</h2>
              <div className="esige-producto-descripcion">
                <ProductoDescripcion text={producto.Info} />
                <ProductoDescripcion text={producto.Descripcion} />
              </div>
            </section>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductoBody;
